import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation, Navigate } from 'react-router-dom';
import './App.css';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './components/Login';
import ProtectedRoute from './components/ProtectedRoute';
import SyncPanel from './components/SyncPanel';
import DealsViewer from './components/DealsViewer';
import PersonsViewer from './components/PersonsViewer';
import WebhooksViewer from './components/WebhooksViewer';
import WebhookConfigsViewer from './components/WebhookConfigsViewer';

function Navigation() {
  const location = useLocation();
  const { user, logout } = useAuth();

  return (
    <nav className="App-nav">
      <div className="nav-tabs">
        <Link
          to="/"
          className={`nav-tab ${location.pathname === '/' ? 'active' : ''}`}
        >
          <span className="tab-icon">🔄</span>
          <span>Sincronización</span>
        </Link>
        <Link
          to="/deals"
          className={`nav-tab ${location.pathname === '/deals' ? 'active' : ''}`}
        >
          <span className="tab-icon">📊</span>
          <span>Deals</span>
        </Link>
        <Link
          to="/persons"
          className={`nav-tab ${location.pathname === '/persons' ? 'active' : ''}`}
        >
          <span className="tab-icon">👥</span>
          <span>Personas</span>
        </Link>
        <Link
          to="/webhooks"
          className={`nav-tab ${location.pathname === '/webhooks' ? 'active' : ''}`}
        >
          <span className="tab-icon">🔔</span>
          <span>Webhooks</span>
        </Link>
        <Link
          to="/webhook-configs"
          className={`nav-tab ${location.pathname === '/webhook-configs' ? 'active' : ''}`}
        >
          <span className="tab-icon">🔗</span>
          <span>Notificaciones</span>
        </Link>
      </div>
      <div className="nav-user">
        <span className="user-name">{user?.name || user?.username}</span>
        <button onClick={logout} className="logout-button">
          Cerrar Sesión
        </button>
      </div>
    </nav>
  );
}

function AppContent() {
  const { isAuthenticated } = useAuth();

  return (
    <div className="App">
      {isAuthenticated && (
        <>
          <header className="App-header">
            <div className="header-content">
              <div className="header-title">
                <h1>Pipedrive Cache</h1>
                <p>Sistema de Sincronización y Visualización</p>
              </div>
            </div>
          </header>
          <Navigation />
        </>
      )}

      <main className="App-main">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <SyncPanel />
              </ProtectedRoute>
            }
          />
          <Route
            path="/deals"
            element={
              <ProtectedRoute>
                <DealsViewer />
              </ProtectedRoute>
            }
          />
          <Route
            path="/persons"
            element={
              <ProtectedRoute>
                <PersonsViewer />
              </ProtectedRoute>
            }
          />
          <Route
            path="/webhooks"
            element={
              <ProtectedRoute>
                <WebhooksViewer />
              </ProtectedRoute>
            }
          />
          <Route
            path="/webhook-configs"
            element={
              <ProtectedRoute>
                <WebhookConfigsViewer />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

export default App;
